<template>
  <nav class="app-navigation" aria-label="主导航">
    <router-link to="/devices"><el-icon><Cellphone /></el-icon><span>云手机</span></router-link>
    <router-link to="/profile"><el-icon><User /></el-icon><span>我的</span></router-link>
  </nav>
</template>
<script setup>
import { Cellphone, User } from '@element-plus/icons-vue'
</script>
<style scoped>
.app-navigation { position: fixed; z-index: 20; bottom: 0; left: 0; right: 0; display: flex; justify-content: center; gap: 32px; padding: 6px 20px calc(6px + env(safe-area-inset-bottom, 0px)); border-top: 1px solid #e9ecef; background: #fbfefe; }
.app-navigation a { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; min-width: 96px; width: 180px; min-height: 48px; color: #8a9597; font-size: 12px; }
.app-navigation .el-icon { font-size: 23px; }
.app-navigation .router-link-active { color: var(--accent); font-weight: 600; }
</style>
